import { render, staticRenderFns } from "./quick-fetching-card.vue?vue&type=template&id=2719e530&scoped=true&"
import script from "./quick-fetching-card.vue?vue&type=script&lang=js&"
export * from "./quick-fetching-card.vue?vue&type=script&lang=js&"
import style0 from "./quick-fetching-card.vue?vue&type=style&index=0&id=2719e530&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2719e530",
  null
  
)

export default component.exports